// source: src/common/opportunity/opportunity_list.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_opportunity_opportunity_pb = require('../../../src/common/opportunity/opportunity_pb.js');
goog.object.extend(proto, src_common_opportunity_opportunity_pb);
goog.exportSymbol('proto.loupe.common.opportunity.OpportunityList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.opportunity.OpportunityList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.opportunity.OpportunityList.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.opportunity.OpportunityList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.opportunity.OpportunityList.displayName = 'proto.loupe.common.opportunity.OpportunityList';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.opportunity.OpportunityList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.opportunity.OpportunityList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.opportunity.OpportunityList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.opportunity.OpportunityList.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunitiesList: jspb.Message.toObjectList(msg.getOpportunitiesList(),
    src_common_opportunity_opportunity_pb.Opportunity.toObject, includeInstance),
    totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextPage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.opportunity.OpportunityList}
 */
proto.loupe.common.opportunity.OpportunityList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.opportunity.OpportunityList;
  return proto.loupe.common.opportunity.OpportunityList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.opportunity.OpportunityList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.opportunity.OpportunityList}
 */
proto.loupe.common.opportunity.OpportunityList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new src_common_opportunity_opportunity_pb.Opportunity;
      reader.readMessage(value,src_common_opportunity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.addOpportunities(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.opportunity.OpportunityList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.opportunity.OpportunityList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.opportunity.OpportunityList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      src_common_opportunity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNextPage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated Opportunity opportunities = 1;
 * @return {!Array<!proto.loupe.common.opportunity.Opportunity>}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.getOpportunitiesList = function() {
  return /** @type{!Array<!proto.loupe.common.opportunity.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_opportunity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {!Array<!proto.loupe.common.opportunity.Opportunity>} value
 * @return {!proto.loupe.common.opportunity.OpportunityList} returns this
*/
proto.loupe.common.opportunity.OpportunityList.prototype.setOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loupe.common.opportunity.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.opportunity.Opportunity}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.addOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loupe.common.opportunity.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.opportunity.OpportunityList} returns this
 */
proto.loupe.common.opportunity.OpportunityList.prototype.clearOpportunitiesList = function() {
  return this.setOpportunitiesList([]);
};


/**
 * optional int64 total_count = 2;
 * @return {number}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.opportunity.OpportunityList} returns this
 */
proto.loupe.common.opportunity.OpportunityList.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string next_page = 3;
 * @return {string}
 */
proto.loupe.common.opportunity.OpportunityList.prototype.getNextPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.opportunity.OpportunityList} returns this
 */
proto.loupe.common.opportunity.OpportunityList.prototype.setNextPage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.loupe.common.opportunity);
